<template>
  <div class="brands-filter alert alert-info rounded rounded-9 p-2 my-2">
    <p class="font-weight-bolder">برند ها</p>
    <div class="form-group form-check" v-for="brand in brands" :key="brand.id">
      <input v-model="selectedBrand" :value="brand.id" name="filter_brands"
             type="checkbox"
             class="form-check-input" :id="`brand_filter_${brand.id}`">
      <label class="form-check-label mr-3" :for="`brand_filter_${brand.id}`">{{ brand.name }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Brand",
  data() {
    return {
      brands: [],
      selectedBrand: [],
    }
  },
  async mounted() {
    let value = this.$route.query.brand;
    if (value != undefined) {
      value = value.split(',')
      this.$store.commit('Product/setFilters', {key: 'brand', value: value})
    }

    this.brands = await this.$store.dispatch('Brand/getBrandsWithoutPagination')
    this.brands = await this.brands.data.data
  },
  watch: {
    selectedBrand: {
      handler(oldValue, newValue) {
        let page = 1
        this.$store.commit("Product/setFilters", {key: "brand", value: this.selectedBrand});
        this.$emit('updateFilter', {brand: this.selectedBrand})
        this.$store.dispatch("Product/setDashboardProducts", page);
      }
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "brand", value: []});
  }
}
</script>

<style scoped>
.brands-filter {
  height: 300px;
  overflow-y: auto;
}
</style>